import { createTheme } from '@mui/material/styles';

export const getDesignTokens = (mode) => {
  const customPalettes = {
    light: {
      primary: { main: '#9242FF' },
      secondary: { main: '#232323' },
      tertiary: { main: '#00FF00' },
      error: { main: '#FFFF00' },
      info: { main: '#E3D0FF' },
      bareColors: { main: '#FFFFFF' },
      primary15: { main: '#9242FF26' },
      primary30: { main: '#9242FF52' },
      neutral: { main: '#ffffff'},
    },
    Cyan: {
      primary: { main: '#00FFFF' },
      secondary: { main: '#232323' },
      tertiary: { main: '#00FF00' },
      error: { main: '#FFFF00' },
      info: { main: '#D0FFFC' },
      bareColors: { main: '#232323' },
      primary15: { main: '#00FFFF26' },
      primary30: { main: '#00FFFF52' },
      neutral: { main: '#ffffff'},
    },
    Green: {
      primary: { main: '#00FF00' },
      secondary: { main: '#232323' },
      tertiary: { main: '#00FFFF' },
      error: { main: '#FFFF00' },
      info: { main: '#D0FFD5' },
      bareColors: { main: '#232323' },
      primary15: { main: '#00FF0026' },
      primary30: { main: '#00FF0052' },
      neutral: { main: '#ffffff'},
    },
    Pink: {
      primary: { main: '#D796FF' },
      secondary: { main: '#232323' },
      tertiary: { main: '#00FF00' },
      error: { main: '#FFFF00' },
      info: { main: '#F8D0FF' },
      bareColors: { main: '#232323' },
      primary15: { main: '#D796FF26' },
      primary30: { main: '#D796FF52' },
      neutral: { main: '#ffffff'},
    },
    LightCyan: {
      primary: { main: '#82FFFF' },
      secondary: { main: '#232323' },
      tertiary: { main: '#00FF00' },
      error: { main: '#FFFF00' },
      info: { main: '#D0FFFC' },
      bareColors: { main: '#232323' },
      primary15: { main: '#00FFFF26' },
      primary30: { main: '#00FFFF52' },
      neutral: { main: '#ffffff'},
    },
    LightGreen: {
      primary: { main: '#79FF79' },
      secondary: { main: '#232323' },
      tertiary: { main: '#00FFFF' },
      error: { main: '#FFFF00' },
      info: { main: '#D0FFD5' },
      bareColors: { main: '#232323' },
      primary15: { main: '#79FF7926' },
      primary30: { main: '#79FF7952' },
      neutral: { main: '#ffffff'},
    },
  };

  const palette = customPalettes[mode];
  if (palette) {
    Object.entries(palette).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value.main);
    });
  }

  return createTheme({
    palette: {
      mode: 'light',
      ...palette,
    },
    customMode: mode,
  });
}
